import SearchTerms from 'arbitrip-common/client/entities/SearchTerms';
export default SearchTerms;
